// extracted by mini-css-extract-plugin
export default {"creditbtn":"cash_creditbtn__a2DnY","cashflx":"cash_cashflx__TN8hv"};